/**
 * @prettier
 */

import React from 'react';
import _sortBy from 'lodash/sortBy';
import { ptToPx } from '../../../../util';
import ImageElement from './ImageElement';
import TextElement from './TextElement';
import styles from './styles.module.less';

const Canvas = ({ page, customizations, width }) => {
  if (!page) return null;

  const { width: widthPt, height: heightPt } = page;

  const templateWidth = ptToPx(widthPt);
  const templateHeight = ptToPx(heightPt);
  const elements = page.elements || [];

  const orderedElements = _sortBy(elements, e => e.layer);

  const customImageIndex = orderedElements.findIndex(
    element => element.content_type === 'IMAGE' && element.customizable
  );

  const renderElement = (element, i) => {
    switch (element.content_type) {
      case 'IMAGE': {
        let customImage;
        if (
          customizations &&
          customizations.photo &&
          customizations.pixelCrop &&
          customImageIndex === i
        ) {
          customImage = { photo: customizations.photo, pixelCrop: customizations.pixelCrop };
        }
        return <ImageElement key={i} element={element} customImage={customImage} />;
      }
      case 'TEXT': {
        return <TextElement key={i} element={element} />;
      }
      default: {
        return null;
      }
    }
  };

  const scale = width / templateWidth;

  return (
    <div className={styles.canvasBox} style={{ height: templateHeight * scale, width }}>
      <div
        className={styles.canvas}
        style={{ width: templateWidth, height: templateHeight, transform: `scale(${scale})` }}
      >
        {orderedElements.map(renderElement)}
      </div>
    </div>
  );
};

Canvas.defaultProps = {
  width: 280,
};

export default Canvas;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SamplePreview/Canvas.jsx